let activeTenantId = ''

// An unresolved booking must survive sign-out/session expiry until its outcome is checked.
export const packagePendingStorageKey = 'salesRepApp_packagePending'

/** Selects the server-resolved immutable tenant identity for this document. */
export function activateCompanyStorage(tenantId: string): void {
  activeTenantId = tenantId
}

/** Namespaces browser state without relying on the editable URL name. */
export function companyStorageKey(key: string): string {
  if (!activeTenantId) throw new Error('Choose a company before saving session state.')
  return `salesRepApp_v2:${encodeURIComponent(activeTenantId)}:${key}`
}

/** Session storage limited to the company active in this browser document. */
export const companySessionStorage = {
  getItem(key: string): string | null { return activeTenantId ? sessionStorage.getItem(companyStorageKey(key)) : null },
  setItem(key: string, value: string): void { sessionStorage.setItem(companyStorageKey(key), value) },
  removeItem(key: string): void { if (activeTenantId) sessionStorage.removeItem(companyStorageKey(key)) }
}

/** Clears authentication and cached data, retaining unresolved booking recovery for this company. */
export function clearCompanySessionStorage(): void {
  if (!activeTenantId) return
  const prefix = companyStorageKey('')
  const pendingBooking = companyStorageKey(packagePendingStorageKey)
  for (const key of Object.keys(sessionStorage)) {
    if (key.startsWith(prefix) && key !== pendingBooking) sessionStorage.removeItem(key)
  }
}
